module.exports = {
	"title": "CSS filter() function",
	"description": "This function filters a CSS input image with a set of filter functions (like blur, grayscale or hue)",
	"spec": "http://www.w3.org/TR/filter-effects/#FilterCSSImageValue",
	"status": "wd",
	"links": [
		{
			"url": "http://iamvdo.me/en/blog/advanced-css-filters#filter",
			"title": "Blog post"
		}
	],
	"bugs": [
		{
			"description": "Firefox feature request: [Mozilla bug #1191043](https://bugzilla.mozilla.org/show_bug.cgi?id=1191043)"
		}
	],
	"categories": [
		"CSS",
		"CSS3"
	],
	"stats": {
		"ie": {
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"5.5": "n"
		},
		"edge": {
			"12": "n",
			"13": "n",
			"14": "n"
		},
		"firefox": {
			"2": "n",
			"3": "n",
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"12": "n",
			"13": "n",
			"14": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "n",
			"25": "n",
			"26": "n",
			"27": "n",
			"28": "n",
			"29": "n",
			"30": "n",
			"31": "n",
			"32": "n",
			"33": "n",
			"34": "n",
			"35": "n",
			"36": "n",
			"37": "n",
			"38": "n",
			"39": "n",
			"40": "n",
			"41": "n",
			"42": "n",
			"43": "n",
			"44": "n",
			"45": "n",
			"46": "n",
			"47": "n",
			"48": "n",
			"49": "n",
			"50": "n",
			"51": "n",
			"52": "n",
			"53": "n",
			"3.5": "n",
			"3.6": "n"
		},
		"chrome": {
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"12": "n",
			"13": "n",
			"14": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "n",
			"25": "n",
			"26": "n",
			"27": "n",
			"28": "n",
			"29": "n",
			"30": "n",
			"31": "n",
			"32": "n",
			"33": "n",
			"34": "n",
			"35": "n",
			"36": "n",
			"37": "n",
			"38": "n",
			"39": "n",
			"40": "n",
			"41": "n",
			"42": "n",
			"43": "n",
			"44": "n",
			"45": "n",
			"46": "n",
			"47": "n",
			"48": "n",
			"49": "n",
			"50": "n",
			"51": "n",
			"52": "n",
			"53": "n",
			"54": "n",
			"55": "n",
			"56": "n",
			"57": "n"
		},
		"safari": {
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "y x",
			"10": "y",
			"3.1": "n",
			"3.2": "n",
			"5.1": "n",
			"6.1": "n",
			"7.1": "n",
			"9.1": "y",
			"TP": "y"
		},
		"opera": {
			"9": "n",
			"11": "n",
			"12": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "n",
			"25": "n",
			"26": "n",
			"27": "n",
			"28": "n",
			"29": "n",
			"30": "n",
			"31": "n",
			"32": "n",
			"33": "n",
			"34": "n",
			"35": "n",
			"36": "n",
			"37": "n",
			"38": "n",
			"39": "n",
			"40": "n",
			"41": "n",
			"42": "n",
			"43": "n",
			"9.5-9.6": "n",
			"10.0-10.1": "n",
			"10.5": "n",
			"10.6": "n",
			"11.1": "n",
			"11.5": "n",
			"11.6": "n",
			"12.1": "n"
		},
		"ios_saf": {
			"8": "n",
			"10": "y x",
			"3.2": "n",
			"4.0-4.1": "n",
			"4.2-4.3": "n",
			"5.0-5.1": "n",
			"6.0-6.1": "n",
			"7.0-7.1": "n",
			"8.1-8.4": "n",
			"9.0-9.2": "y x",
			"9.3": "y x"
		},
		"op_mini": {
			"all": "n"
		},
		"android": {
			"3": "n",
			"4": "n",
			"53": "n",
			"2.1": "n",
			"2.2": "n",
			"2.3": "n",
			"4.1": "n",
			"4.2-4.3": "n",
			"4.4": "n",
			"4.4.3-4.4.4": "n"
		},
		"bb": {
			"7": "n",
			"10": "n"
		},
		"op_mob": {
			"10": "n",
			"11": "n",
			"12": "n",
			"37": "n",
			"11.1": "n",
			"11.5": "n",
			"12.1": "n"
		},
		"and_chr": {
			"53": "n"
		},
		"and_ff": {
			"49": "n"
		},
		"ie_mob": {
			"10": "n",
			"11": "n"
		},
		"and_uc": {
			"11": "n"
		},
		"samsung": {
			"4": "n"
		}
	},
	"notes": "",
	"notes_by_num": {},
	"usage_perc_y": 10.65,
	"usage_perc_a": 0,
	"ucprefix": false,
	"parent": "",
	"keywords": "filter, function",
	"ie_id": "cssfilterimagefunction",
	"chrome_id": "5425136400334848",
	"firefox_id": "",
	"webkit_id": "",
	"shown": true
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/features-json/css-filter-function.json
 ** module id = 418
 ** module chunks = 0
 **/